import { Form} from "@progress/kendo-react-form"
import {Checkbox} from "@progress/kendo-react-inputs"
import React ,{useEffect, useState} from "react"
import {filterBy} from "@progress/kendo-data-query"
import {fetchDateRangeReport} from "../../../../containers/PassRate/passRateReportSlice"
import {RootState} from "../../../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../../../store"
import {MDBCol, MDBRow} from "mdbreact"
import { DateRangePicker, DateRangePickerChangeEvent } from "@progress/kendo-react-dateinputs"
import { Button } from "@progress/kendo-react-buttons"
import { FeesReportParams } from "../../../../containers/MotBooking/bookingSlice"
import {
    ListItemProps,
    MultiSelect,
    MultiSelectChangeEvent,
    MultiSelectFilterChangeEvent,
} from "@progress/kendo-react-dropdowns"


const PassRateDetailsDateRangeFilter = () => {
    const dispatch = useAppDispatch()
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)
    // const selectedDealers = useAppSelector((state: RootState) => state.application.selectedMultipleDealer)
    const [dateValidation, setDateRangeValid] = useState(true)
    const [dealerData, setDealersData] = useState(userDealers)
    const feesReportFilter = useAppSelector((state: RootState) => state.containers.motBooking.feeReportFilters)
    const [filterParam, setFilterParams] = useState<FeesReportParams>({
           dateRange: feesReportFilter.dateRange,
           dealerIds: [] ,
           searchText: feesReportFilter.searchText,
       })
   
    useEffect(() => {
        if(userDealers.length > 0) {
            setDealersData(userDealers)
        }
         const preparerIds = filterParam.dealerIds.length === 0 ? dealerData.filter(dealer => dealer.preparerId).map((dealer) => dealer.preparerId).join(",") : filterParam.dealerIds.filter(dealer => dealer.preparerId).map((dealer) => dealer.preparerId).join(",") 
        filterParam.dateRange && filterParam.dateRange.start && filterParam.dateRange.end &&  dispatch(fetchDateRangeReport(filterParam.dateRange, preparerIds))
    }, [dispatch,userDealers])

     const submitHandler = () => {
            const preparerIds = filterParam.dealerIds.length === 0 ? dealerData.filter(dealer => dealer.preparerId).map((dealer) => dealer.preparerId).join(",") : filterParam.dealerIds.filter(dealer => dealer.preparerId).map((dealer) => dealer.preparerId).join(",") 
            filterParam.dateRange && filterParam.dateRange.start && filterParam.dateRange.end && dispatch(fetchDateRangeReport(filterParam.dateRange, preparerIds))
        }
    const onDealerChange = (e: MultiSelectChangeEvent) => {
        setFilterParams((prevValue: any) => ({
            ...prevValue,
            dealerIds: e.value,
        }))
    }
    const dealerItemRender = (li: React.ReactElement<HTMLLIElement>, itemProps: ListItemProps) => {
            const itemChildren = (
                <span className="reportcheckbox">
                    <Checkbox checked={itemProps.selected} onChange={() => {}} />
                    &nbsp;{li.props.children}
                </span>
            )
            return React.cloneElement(li, li.props, itemChildren)
        }
    const onDateChange = (event: DateRangePickerChangeEvent) => {
        event.value.start === null || setDateRangeValid(event.value.end !== null)
        setFilterParams((prevValue: any) => ({
            ...prevValue,
            dateRange: event.value,
        }))
    }
    const selected = filterParam.dealerIds.length
    return (
        <div>
            <Form
                render={() => (
                     <div style={{width: "700px"}}>
                     <MDBRow className="align-items-end mb-2">
                            <MDBCol md="5" sm="4">
                                <DateRangePicker
                                    valid={dateValidation}
                                    value={filterParam.dateRange}
                                    onChange={onDateChange}
                                />
                            </MDBCol>
                              <MDBCol md="5" sm="5">
                               <MultiSelect
                                    className="reportmultiselect"
                                        autoClose={false}
                                        filterable={true}
                                        onFilterChange={(event: MultiSelectFilterChangeEvent) => {
                                            setDealersData(filterBy(userDealers.slice(), event.filter))
                                        }}
                                        dataItemKey="dealerId"
                                        textField="dealerName"
                                        label={"Dealers"}
                                        data={dealerData}
                                        onChange={onDealerChange}
                                        value={filterParam.dealerIds}
                                        tags={
                                            selected > 0
                                                ? [{text: `${selected} selected`, data: [...filterParam.dealerIds]}]
                                                : []
                                        }
                                        itemRender={dealerItemRender}
                                    />
                            </MDBCol>
                            <MDBCol>
                                <div className="k-form-buttons mt-auto">
                                    <Button
                                        type="submit"
                                        fillMode="flat"
                                        themeColor={"primary"}
                                        onClick={submitHandler}
                                    >
                                        Go
                                    </Button>
                                </div>
                            </MDBCol>
                        </MDBRow>
                    </div>
                )}
            />
        </div>
    )
}

export default PassRateDetailsDateRangeFilter
